/**
 * 顔認証の登録済みバッジ。
 * 打刻画面・プロフィール等で名前の横に表示する。
 * 状態はサーバ（/auth/face-status）を優先し、オフライン時は端末キャッシュで判定。
 * モジュール内キャッシュで画面遷移のたびのAPI呼び出しを避ける。
 * 登録・削除の直後は invalidateFaceBadgeCache() を呼んで最新化する。
 */
import React, { useState, useEffect } from 'react';
import { apiFetch } from '../services/api';
import { hasLocalFace } from '../hooks/useFaceAuth';

let cached: { userId: string; registered: boolean } | null = null;

/** 登録・削除後に呼ぶとバッジ表示が次回描画で最新化される */
export function invalidateFaceBadgeCache(): void { cached = null; }

export const FaceBadge: React.FC<{ userId: string; size?: 'sm' | 'md' }> = ({ userId, size = 'sm' }) => {
  const [registered, setRegistered] = useState<boolean>(() =>
    cached?.userId === userId ? cached.registered : hasLocalFace(userId));

  useEffect(() => {
    if (cached?.userId === userId) { setRegistered(cached.registered); return; }
    let alive = true;
    apiFetch<{ data: { registered: boolean } }>('/auth/face-status')
      .then(res => {
        const r = res.data.registered || hasLocalFace(userId);
        cached = { userId, registered: r };
        if (alive) setRegistered(r);
      })
      .catch(() => {
        const r = hasLocalFace(userId);
        cached = { userId, registered: r };
        if (alive) setRegistered(r);
      });
    return () => { alive = false; };
  }, [userId]);

  if (!registered) return null;
  const sm = size === 'sm';
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 3,
      fontSize: sm ? 10 : 11, fontWeight: 700, color: '#059669',
      background: '#ecfdf5', border: '1px solid #a7f3d0', borderRadius: 999,
      padding: sm ? '1px 7px' : '2px 9px', whiteSpace: 'nowrap', verticalAlign: 'middle',
    }}>
      🙂 顔認証済み
    </span>
  );
};

export default FaceBadge;
